module.exports = __webpack_public_path__ + "img/gatilogo.9b2f9880.png";